import { Component } from 'react';
import PropTypes from 'prop-types';
import segmentioSnippet from '@segment/snippet';

const propTypes = {
  apiKey: PropTypes.string.isRequired,
  host: PropTypes.string,
};

const defaultProps = {
  host: 'cdn.segment.com',
};

class Segment extends Component {
  shouldComponentUpdate(nextProps) {
    const apiKeyChanged = nextProps.apiKey !== this.props.apiKey;
    const hostChanged = nextProps.host !== this.props.host;

    return apiKeyChanged || hostChanged;
  }

  createSnippet = () => {
    const { apiKey, host } = this.props;

    return segmentioSnippet.min({
      apiKey,
      host,
      page: false,
    });
  };

  render() {
    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.id = 'segment-tag';
    scriptTag.appendChild(document.createTextNode(this.createSnippet()));
    document.body.appendChild(scriptTag);

    return null;
  }
}

Segment.propTypes = propTypes;
Segment.defaultProps = defaultProps;

export default Segment;



// WEBPACK FOOTER //
// ../ui-components/components/Segment/index.jsx